<div
  *ngIf="unassignedTins.length > 0"
  class="cg-margin-bottom-md"
  data-test="wam-table-tins-awaiting"
>
  <div class="cg-margin-bottom-sm" data-test="cg-unassigned-tin-header">
    <strong>Awaiting Approval</strong>
  </div>
  <ng-container *ngFor="let item of unassignedTins; let i = index">
    <div
      *ngIf="i < show"
      class="cg-margin-bottom-xs"
      data-test="cg-unassigned-tin"
    >
      {{ item }}
    </div>
    <ng-container *ngIf="i >= show">
      <div
        *ngIf="expanded"
        class="cg-margin-bottom-xs"
        data-test="cg-unassigned-tin"
      >
        {{ item }}
      </div>
    </ng-container>
  </ng-container>
</div>

<div
  *ngIf="assignedTins.length > 0 && (unassignedTins.length < show || expanded)"
  data-test="wam-table-tins-existing"
>
  <div class="cg-margin-bottom-sm" data-test="cg-assigned-tin-header">
    <strong>Existing</strong>
  </div>
  <ng-container *ngFor="let item of assignedTins; let i = index">
    <div
      *ngIf="i + unassignedTins.length < show"
      class="cg-margin-bottom-xs"
      data-test="cg-assigned-tin"
    >
      {{ item }}
    </div>
    <ng-container *ngIf="i + unassignedTins.length >= show">
      <div
        *ngIf="expanded"
        class="cg-margin-bottom-xs"
        data-test="cg-assigned-tin"
      >
        {{ item }}
      </div>
    </ng-container>
  </ng-container>
</div>

<button
  *ngIf="!expanded && totalItems > show"
  data-test="wam-table-tins-more-link"
  cignaButton="link"
  (click)="showMore()"
  class="cg-flush-button-link"
>
  more...
</button>
